import {
  Content,
  Flex,
  Grid,
  OverflowTooltip,
  usePlatformProps,
} from '@acsbe/ui';
import { FunctionComponent, PropsWithChildren } from 'react';
import { BillingMethod } from '../../../context/BillingContext';
import { BillingDetails } from './billing-details';
import { CardGraphic } from './card-graphic';

type BillingCardCompactProps = PropsWithChildren & {
  card: BillingMethod;
  disabled?: boolean;
};

export const BillingCardCompact: FunctionComponent<BillingCardCompactProps> = ({
  card,
  disabled,
  children,
}) => {
  const p = usePlatformProps();

  return (
    <Flex
      row
      align="center"
      gap={3}
      {...p.uptoPhablet({ row: false, align: 'start', gap: 2 })}
    >
      <CardGraphic small card={card} disabled={disabled} />

      <Flex gap={1} width="100%">
        <Grid minHeight="24px" cols="auto 1fr" gap={2} align="center">
          <Flex minWidth="0px" overflow="hidden">
            <OverflowTooltip
              scale="invert"
              content={
                <Content scale="invert" inline break="break-all">
                  {card.name}
                </Content>
              }
            >
              <Content
                clip
                wrap={false}
                emphasis="low"
                variant={disabled ? 'element' : 'static'}
                scale={disabled ? 'disabled' : 'base'}
              >
                {card.name}
              </Content>
            </OverflowTooltip>
          </Flex>

          <Flex align="start">{children}</Flex>
        </Grid>

        <Flex row align="center" justify="space-between" gap={2} wrap="wrap">
          <BillingDetails
            isInvalid={disabled}
            country={card.country}
            zipCode={card.zipCode}
            cardDigits={card.cardDigits}
            expiryMonth={card.cardExpiryMonth}
            expiryYear={card.cardExpiryYear}
            size="smb"
          />
        </Flex>
      </Flex>
    </Flex>
  );
};
